module.exports = __webpack_public_path__ + "img/image-expand.815d0843.png";